import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { License } from "src/app/shared/models/license.model";
import { PrinterJobItem } from "src/app/shared/models/PrintJobItem.model";
import { PrintOrder } from "src/app/shared/models/PrintOrder";

@Component({
	selector: "app-kitchen-print-order-record",
	templateUrl: "./kitchen-print-order-record.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class KitchenPrintOrderRecordComponent implements OnInit, OnChanges {
	@Input() printJobItem: PrinterJobItem;
	@Output() printJobItemChange = new EventEmitter<PrinterJobItem>();

	@Input() printOrder: PrintOrder;
	@Output() printOrderChange = new EventEmitter<PrintOrder>();

	device: License;

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}
	ngOnChanges(changes: SimpleChanges): void {
		this.device = this.venueService.licenses.value?.find((i) => i.key === this.printOrder.licenseKey);
	}

	ngOnInit(): void {
		this.device = this.venueService.licenses.value?.find((i) => i.key === this.printOrder.licenseKey);
	}
}
